<app-breadcrumb [title]="'Unlock Application Details'"></app-breadcrumb>


<app-loader [show]="skeleton"></app-loader>
<div [class.d-none]="skeleton">
  <div class="row">
  <div class="col-md-3 bg-white rounded shadow">
    <div class="pl-3 pr-5">
      <app-navbar [step]="0">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <div class="row">
        <div class="col-md-12 text-center">
            <h4 class="description text-default">Looks like you want to unlock your application.</h4>
        </div>
    </div>

    <div class="d-flex justify-content-end">
        <button *ngIf="transferRequest && transferRequest.isConfirm" type="button" (click)="unconfirm()"
            class="btn btn-danger rounded-0">UnLock Application</button>
    </div>
</div>
</div>
</div>
